module.exports = __webpack_public_path__ + "static/media/referral-response.b7ba2ae1.svg";